import React, { useEffect, useState } from "react";
import { getProducts } from "../services/api";
import ProductCard from "../components/ProductCard";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const settings = useSettings();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getProducts();
        setProducts(data);
      } catch (err) {
        console.error("Error loading products:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const pageTitle = `Koleksi Produk - ${settings.site_name || "HandyCraft Bali"}`;
  const pageDesc = "Jelajahi berbagai pilihan kerajinan tangan Bali terbaik, mulai dari tas rotan hingga ukiran kayu otentik.";
  const thumbnailUrl = `${window.location.origin}/assets/branding/thumbnail.png`;

  return (
    <div className="container" style={{ paddingTop: '40px', paddingBottom: '80px' }}>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDesc} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:image" content={thumbnailUrl} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
        <meta name="twitter:image" content={thumbnailUrl} />
      </Helmet>

      <div className="section-header" style={{ textAlign: 'left', marginBottom: '40px' }}>
        <p>Koleksi Lengkap</p>
        <h2 className="section-title">Semua Produk Kerajinan Bali</h2>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '100px 0' }}>Memuat koleksi produk...</div>
      ) : (
        <div className="products-grid">
          {products.length > 0 ? (
            products.map((p) => <ProductCard key={p.id} product={p} />)
          ) : (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '100px 0', background: 'white', borderRadius: '30px', border: '1px solid var(--border)' }}>
              <p style={{ color: '#666', fontSize: '1.1rem' }}>
                Belum ada produk dalam koleksi saat ini.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
